var TrackingExperimentClient = /** @class */ (function () {
    function TrackingExperimentClient(underlyingExperimentClient, config) {
        this.underlyingExperimentClient = underlyingExperimentClient;
        this.config = config;
        this.tracked = {};
        this.treatment = this.treatment.bind(this);
    }
    TrackingExperimentClient.prototype.treatment = function (_a) {
        var _this = this;
        var id = _a.id, experiment = _a.experiment, attributes = _a.attributes, options = _a.options, defaultTreatment = _a.defaultTreatment;
        /**
         * Although not required, the default treatment must be passed into this first underlying client.
         * If we are using an override client it might use the default treatment
         */
        var treatment = this.underlyingExperimentClient.treatment({
            id: id,
            experiment: experiment,
            attributes: attributes,
            options: options,
            defaultTreatment: defaultTreatment
        });
        /**
         * Don't track if:
         * 1. skipping the experiment
         * 2. explicitely suprressing tracking
         * 3. overriding the experiemnt
         * 4. forcing default treatments (we do this for bots, such as scrapers, synthetic monitoring, and e2e testing)
         */
        if (options.skip ||
            options.suppressTracking ||
            this.config.experimentOverrides ||
            this.config.forceDefaultTreatments) {
            return treatment;
        }
        Promise.all([treatment.promise, treatment.active, treatment.changeNumber]).then(function (_a) {
            var variation = _a[0], active = _a[1], changeNumber = _a[2];
            // Additionally do not track if the experiment is inactive (killed/resolved)
            if (!active) {
                return;
            }
            if (!_this.tracked[id]) {
                _this.tracked[id] = {};
            }
            if (_this.tracked[id][experiment] !== variation) {
                _this.config.onExperimentViewed &&
                    _this.config.onExperimentViewed({
                        experiment: experiment,
                        variation: variation,
                        nonInteraction: 1,
                        changeNumber: changeNumber
                    });
                _this.tracked[id][experiment] = variation;
            }
        });
        return treatment;
    };
    return TrackingExperimentClient;
}());

export { TrackingExperimentClient };
//# sourceMappingURL=tracking-browser.js.map
